/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scenarioActivationIntegrationResultSchema } from './scenarioActivationIntegrationResultSchema';

export const scenarioActivationResponseSchema = z.object({
  get integrationResults() {
    return z.array(scenarioActivationIntegrationResultSchema);
  },
});
